<div class="flex h-screen bg-gray-100 font-sans text-sm">
  <!-- Left Sidebar (Inbox) -->
  <aside class="w-64 bg-white border-r flex flex-col p-4 space-y-4">
    <app-left-sidebar></app-left-sidebar>
  </aside>

  <!-- Main Content -->
  <main class="flex-1 flex flex-col bg-purple-50 overflow-y-auto">
    <header class="p-4 border-b bg-white">
      <h1 class="text-xl font-bold text-purple-800">Ključne reči</h1>
      <p class="text-xs text-gray-500 mt-1">Upravljanje prefiksima i ključnim rečima</p>
    </header>

    <div class="flex-1 p-6 grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
      <!-- Keywords card -->
      <section class="bg-white border rounded-xl shadow-sm overflow-hidden">
        <div class="px-5 py-4 border-b flex items-center justify-between">
          <h2 class="font-bold text-purple-700">Keywords</h2>
          <span class="text-xs font-semibold text-purple-700 bg-purple-100 rounded-full px-2 py-0.5">
            {{ keywords().length }}
          </span>
        </div>

        <div class="max-h-72 overflow-y-auto divide-y">
          @for (keyword of keywords(); track keyword.id) {
            <div class="px-5 py-3 flex items-center gap-2 hover:bg-purple-50/60 transition-colors">
              <span class="text-xs font-mono font-bold text-purple-700 bg-purple-100 rounded px-2 py-0.5">
                {{ keyword.prefix_code }}
              </span>
              <span class="text-gray-700">{{ keyword.code }}</span>
            </div>
          } @empty {
            <p class="px-5 py-6 text-center text-gray-400">Nema dodatih keyword-a.</p>
          }
        </div>

        <form [formRoot]="keywordForm" class="px-5 py-4 border-t bg-gray-50/60 space-y-3">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Novi keyword</label>
            <input
              type="text"
              placeholder="Unesi keyword..."
              class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
              [formField]="keywordForm.keyword"
            />
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Prefix</label>
            <select
              class="w-full border rounded-lg p-2 bg-white focus:ring-2 focus:ring-purple-500 outline-none"
              [class.border-red-500]="keywordForm.prefixId().invalid() && keywordForm.prefixId().touched()"
              name="prefixId"
              [value]="keywordModel().prefixId"
              (change)="updatePrefixId($event)"
            >
              <option value="0">Izaberi prefix</option>
              @for (prefix of prefixes(); track prefix.id) {
                <option [value]="prefix.id">{{ prefix.prefix_code }}</option>
              }
            </select>
            @if (keywordForm.prefixId().invalid() && keywordForm.prefixId().touched()) {
              <p class="text-xs text-red-600">Izaberi prefix pre dodavanja keyword-a.</p>
            }
          </div>
          <button
            class="w-full px-8 py-2 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition-colors"
            type="submit"
          >
            Dodaj keyword
          </button>
        </form>
      </section>

      <!-- Prefixes card -->
      <section class="bg-white border rounded-xl shadow-sm overflow-hidden">
        <div class="px-5 py-4 border-b flex items-center justify-between">
          <h2 class="font-bold text-purple-700">Prefixes</h2>
          <span class="text-xs font-semibold text-purple-700 bg-purple-100 rounded-full px-2 py-0.5">
            {{ prefixes().length }}
          </span>
        </div>

        <div class="px-5 py-4 flex flex-wrap gap-2 max-h-72 overflow-y-auto">
          @for (prefix of prefixes(); track prefix.id) {
            <span class="text-xs font-mono font-bold text-purple-700 bg-purple-100 rounded-full px-3 py-1">
              {{ prefix.prefix_code }}
            </span>
          } @empty {
            <p class="w-full text-center text-gray-400 py-6">Nema dodatih prefixa.</p>
          }
        </div>

        <form [formRoot]="prefixForm" class="px-5 py-4 border-t bg-gray-50/60 space-y-3">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-bold uppercase text-gray-500">Novi prefix</label>
            <input
              type="text"
              placeholder="Unesi prefix..."
              class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
              [formField]="prefixForm.prefix"
            />
          </div>
          <button
            class="w-full px-8 py-2 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition-colors"
            type="submit"
          >
            Dodaj prefix
          </button>
        </form>
      </section>
    </div>
  </main>
</div>
